<shared-loyalty-cta *ngIf="isLoyaltyHomePage$ | async"></shared-loyalty-cta>